import request from '@/utils/request';

//模板列表数据
export function getQueryMailSendLogPage(values) {
  return request('/mail/queryMailSendLogPage', {
    method: 'POST',
    data: values,
  });
}
